"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sort = void 0;
function sort(arg1, arg2, direction) {
    if (direction === void 0) { direction = 'asc'; }
    if (arg1 === null || arg2 === null) {
        if (direction === 'asc') {
            return arg1 === null ? -1 : 1;
        }
        return arg1 === null ? 1 : -1;
    }
    if (typeof arg1 !== typeof arg2) {
        throw new Error('Sorting of incosistent types not supported');
    }
    if (typeof arg1 === 'string' && typeof arg2 === 'string') {
        // eslint-disable-next-line no-nested-ternary
        return direction === 'asc'
            ? arg1.toLocaleString().toUpperCase() > arg2.toLocaleString().toUpperCase()
                ? 1
                : -1
            : arg1.toLocaleString().toUpperCase() > arg2.toLocaleString().toUpperCase()
                ? -1
                : 1;
    }
    if (typeof arg1 === 'number' && typeof arg2 === 'number') {
        return direction === 'asc' ? arg1 - arg2 : arg2 - arg1;
    }
    // We should never hit this, but Typescript is unable to work that out for itself.
    throw new Error('Sorting of strings or numbers only supported');
}
exports.sort = sort;
